import { fetchBankInfo } from '@/lib/api/fetchBankInfo';
import { getAdvisorDetails, getAdvisorDetailsCtor, axiosInstance as restInstance } from '@/lib/advisors/getAdvisorDetails';
import { camelify } from '@/helpers/case';

export default {
  state: {
    bankInfo: {},
    advisor: {},
  },
  getters: {
    bankInfo(state) {
      return state.bankInfo;
    },
    advisor(state) {
      return state.advisor;
    }
  },
  mutations: {
    updateBankInfo(state, bankInfo) {
      state.bankInfo = bankInfo;
    },
    setLoadingAdvisor(state, loadingAdvisor) {
      state.loadingAdvisor = loadingAdvisor;
    },
    updateAdvisor(state, advisorInfo) {
      state.advisorInfo = advisorInfo;
    }
  },
  actions: {
    async fetchBankInfo({ commit }, bankNumbers) {
      const bankInfo = await fetchBankInfo(bankNumbers);
      commit('updateBankInfo', bankInfo);
      return bankInfo;
    },
    async fetchAdvisor({ commit, rootGetters }) {
      commit('setLoadingAdvisor', true);
      try {
        const axiosInstance = await restInstance(rootGetters?.ciToken || null);
        const advisorGetDetails = getAdvisorDetailsCtor({ axiosInstance });
        let advisor;
        if(advisorGetDetails) {
          advisor = await advisorGetDetails();
          commit('updateAdvisor', camelify(advisor));
        }
        commit('setLoadingAdvisor', false);
        return advisor;
      } catch(e) {
        commit('setLoadingAdvisor', false);
        return Promise.reject(e);
      } 
    },
  },
};